
const basket = [
  {
    "_id": "67f4336721a917db64176bf7",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057188/jtypgy1l1pqaeepdwaxx.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057188/jtypgy1l1pqaeepdwaxx.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f4336721a917db64176bf8"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057189/dkp7s9fpqvykb1te9jdb.jpg",
        "_id": "67f4336721a917db64176bf9"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057190/gm7zkk6vhs0wuewb2lx7.jpg",
        "_id": "67f4336721a917db64176bfa"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057191/zerrddqfffarxsu8uhkb.jpg",
        "_id": "67f4336721a917db64176bfb"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx"
  },
  {
    "_id": "67f4338121a917db64176bff",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057212/hd8pyvvhuahbyry0sd53.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057212/hd8pyvvhuahbyry0sd53.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f4338121a917db64176c00"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057214/mtplyzezbgzlzjfzl1cr.jpg",
        "_id": "67f4338121a917db64176c01"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057214/nsnnqpc5ipvjd5n90hmm.jpg",
        "_id": "67f4338121a917db64176c02"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057216/b520jgfggsdcqivbseug.jpg",
        "_id": "67f4338121a917db64176c03"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057217/i13sv3afpnanmggxrjhs.jpg",
        "_id": "67f4338121a917db64176c04"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-1"
  },
  {
    "_id": "67f4339321a917db64176c0d",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057232/sq2evxse6dzpqoxoxsmu.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057232/sq2evxse6dzpqoxoxsmu.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f4339321a917db64176c0e"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057233/hbwyf9hqgverhzrajdss.jpg",
        "_id": "67f4339321a917db64176c0f"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057234/ntwde2unexsrqt18gind.jpg",
        "_id": "67f4339321a917db64176c10"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057235/iwgvqqsfmqmrqf5oeiik.jpg",
        "_id": "67f4339321a917db64176c11"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-2"
  },
  {
    "_id": "67f433cf21a917db64176c20",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057295/u4qbzlbm8bgn4yesxg6x.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057295/u4qbzlbm8bgn4yesxg6x.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f433cf21a917db64176c21"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-3"
  },
  {
    "_id": "67f433e721a917db64176c35",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057319/uqtxoybgkznkfnqgkyep.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057319/uqtxoybgkznkfnqgkyep.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f433e721a917db64176c36"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-4"
  },
  {
    "_id": "67f433f421a917db64176c4c",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057331/aq9kcf5yf8cpbj0bsvoe.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057331/aq9kcf5yf8cpbj0bsvoe.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f433f421a917db64176c4d"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-5"
  },
  {
    "_id": "67f4340221a917db64176c65",
    "title": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057345/ewcehrhcsuotslfysvu4.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057345/ewcehrhcsuotslfysvu4.jpg",
        "alt": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 24 x 14 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f4340221a917db64176c66"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-24-x-14-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx-6"
  },
  {
    "_id": "67f4343721a917db64176c80",
    "title": "Juteify Cute Jute Basket – 20 x 20 x 20 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057395/z6tfda25f86vx0xlxrzg.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057395/z6tfda25f86vx0xlxrzg.jpg",
        "alt": "Juteify Cute Jute Basket – 20 x 20 x 20 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom.  Model",
        "dataAltText": "Juteify Cute Jute Basket – 20 x 20 x 20 cm | Natural Jute Storage Organizer for Home, Kitchen, Office & Bathroom. ",
        "_id": "67f4343721a917db64176c81"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057396/mqp3tq6cwlxlsnzx9vsg.jpg",
        "_id": "67f4343721a917db64176c82"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057397/ltklbhazgvhh7g9jelf6.jpg",
        "_id": "67f4343721a917db64176c83"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057398/whinf1x6lgykfraityx7.jpg",
        "_id": "67f4343721a917db64176c84"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057399/ols0sitpcwg5lvwzwxso.jpg",
        "_id": "67f4343721a917db64176c85"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-cute-jute-basket-20-x-20-x-20-cm-or-natural-jute-storage-organizer-for-home-kitchen-office-and-bathroom.-jutexx"
  },
  {
    "_id": "682f1dbc598e015aa2cd0b68",
    "title": "Jutexx Woven Wicker Storage Basket Closure, Handmade Kids Gift Basket Organizer (Purple)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dn6mtzcht/image/upload/v1747918267/ujnkuktky1dq5vqgq4t5.jpg",
        "dataAltImage": "http://res.cloudinary.com/dn6mtzcht/image/upload/v1747918267/ujnkuktky1dq5vqgq4t5.jpg",
        "alt": "Jutexx Woven Wicker Storage Basket Closure, Handmade Kids Gift Basket Organizer (Purple) Model",
        "dataAltText": "Jutexx Woven Wicker Storage Basket Closure, Handmade Kids Gift Basket Organizer (Purple)",
        "_id": "682f1dbc598e015aa2cd0b69"
      }
    ],
    "price": "Rs.499.00",
    "slug": "jutexx-woven-wicker-storage-basket-closure-handmade-kids-gift-basket-organizer-(purple)-jutexx"
  }
]

const bowl = [
  {
    "_id": "67f42ed6faa830c092a3e68b",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056021/j985dgxlmad989mfun3e.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056021/j985dgxlmad989mfun3e.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42ed6faa830c092a3e68c"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx"
  },
  {
    "_id": "67f42ee7faa830c092a3e699",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056038/xupbnkd42yqq8jbkd1l4.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056038/xupbnkd42yqq8jbkd1l4.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42ee7faa830c092a3e69a"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-1"
  },
  {
    "_id": "67f42f0afaa830c092a3e6a9",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056074/zto4ijzqhvrveim8zjef.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056074/zto4ijzqhvrveim8zjef.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42f0afaa830c092a3e6aa"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-2"
  },
  {
    "_id": "67f42f17faa830c092a3e6bb",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056087/faungukpj48lsjzdvvlk.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056087/faungukpj48lsjzdvvlk.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42f17faa830c092a3e6bc"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-3"
  },
  {
    "_id": "67f42f27faa830c092a3e6cf",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056103/esdnp2mimycjodvb16c8.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056103/esdnp2mimycjodvb16c8.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42f27faa830c092a3e6d0"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-4"
  },
  {
    "_id": "67f42f31faa830c092a3e6e5",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056113/lqhdjuq2aiutp7awivco.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056113/lqhdjuq2aiutp7awivco.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42f31faa830c092a3e6e6"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-5"
  },
  {
    "_id": "67f42f3efaa830c092a3e6fd",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056126/djpupdzpbfmbfeoqe7tl.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056126/djpupdzpbfmbfeoqe7tl.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Joker)",
        "_id": "67f42f3efaa830c092a3e6fe"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-6"
  },
  {
    "_id": "67f4301efaa830c092a3e9a9",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056350/vwztv6emknxnaj4pc5iv.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056350/vwztv6emknxnaj4pc5iv.jpg",
        "alt": "Juteify Cute Jute Bowl for Kitchen  Model",
        "dataAltText": "Juteify Cute Jute Bowl for Kitchen ",
        "_id": "67f4301efaa830c092a3e9aa"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-7"
  },
  {
    "_id": "67f43029faa830c092a3e9bc",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056361/apxrfpbxvbwhdm6cxjrq.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056361/apxrfpbxvbwhdm6cxjrq.jpg",
        "alt": "Juteify Cute Jute Bowl for Kitchen  Model",
        "dataAltText": "Juteify Cute Jute Bowl for Kitchen ",
        "_id": "67f43029faa830c092a3e9bd"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-8"
  },
  {
    "_id": "67f430c5faa830c092a3e9d1",
    "title": "Juteify Cute Jute Bowl for Kitchen ",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056517/zg0qdtegtowohuavrk3k.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056517/zg0qdtegtowohuavrk3k.jpg",
        "alt": "Juteify Cute Jute Bowl for Kitchen  Model",
        "dataAltText": "Juteify Cute Jute Bowl for Kitchen ",
        "_id": "67f430c5faa830c092a3e9d2"
      }
    ],
    "price": "Rs.699.00",
    "slug": "juteify-cute-jute-bowl-for-kitchen-jutexx-9"
  }
]

const lBags = [
 
  {
    "_id": "67f41cffc21fa74899f0af2d",
    "title": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051455/fdlgp1flaleon2svkuy2.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051455/fdlgp1flaleon2svkuy2.jpg",
        "alt": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom Model",
        "dataAltText": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
        "_id": "67f41cffc21fa74899f0af2e"
      }
    ],
    "price": "Rs.899.00",
    "slug": "juteify-laundary-basket-without-lid-storage-baskets-for-bathroom-jutexx-5"
  },
  {
    "_id": "67f41d26c21fa74899f0af65",
    "title": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051494/zmoravffet3niyg9otap.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051494/zmoravffet3niyg9otap.jpg",
        "alt": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom Model",
        "dataAltText": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
        "_id": "67f41d26c21fa74899f0af66"
      }
    ],
    "price": "Rs.899.00",
    "slug": "juteify-laundary-basket-without-lid-storage-baskets-for-bathroom-jutexx-6"
  },
  {
    "_id": "67f41d4bc21fa74899f0af9f",
    "title": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051531/uuoivkyrnmogaxzg2uqp.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051531/uuoivkyrnmogaxzg2uqp.jpg",
        "alt": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom Model",
        "dataAltText": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
        "_id": "67f41d4bc21fa74899f0afa0"
      }
    ],
    "price": "Rs.899.00",
    "slug": "juteify-laundary-basket-without-lid-storage-baskets-for-bathroom-jutexx-7"
  },
  {
    "_id": "67f41dcac21fa74899f0afdb",
    "title": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051657/j6saalk2vcvct8ib0jzv.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051657/j6saalk2vcvct8ib0jzv.jpg",
        "alt": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom Model",
        "dataAltText": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
        "_id": "67f41dcac21fa74899f0afdc"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051658/eolbxocbt7bimymenxyl.jpg",
        "_id": "67f41dcac21fa74899f0afdd"
      }
    ],
    "price": "Rs.899.00",
    "slug": "juteify-laundary-basket-without-lid-storage-baskets-for-bathroom-jutexx-8"
  },
  {
    "_id": "67f42b0afaa830c092a3d8ba",
    "title": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744055050/c6xzzascevrduncbplf2.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744055050/c6xzzascevrduncbplf2.jpg",
        "alt": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom Model",
        "dataAltText": "Juteify Laundary Basket without Lid Storage Baskets for Bathroom",
        "_id": "67f42b0afaa830c092a3d8bb"
      }
    ],
    "price": "Rs.899.00",
    "slug": "juteify-laundary-basket-without-lid-storage-baskets-for-bathroom-jutexx-9"
  }
]

const matka = [
  {
    "_id": "67f421defaa830c092a3989b",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052699/tpur6oeaeu1pnp9syny2.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052699/tpur6oeaeu1pnp9syny2.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f421defaa830c092a3989c"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052700/howhrvnzab5iggi864yr.jpg",
        "_id": "67f421defaa830c092a3989d"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052701/jbpocuqphnax5tqlogku.jpg",
        "_id": "67f421defaa830c092a3989e"
      },
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052701/l0nj27ba3khi5egy7ro7.jpg",
        "_id": "67f421defaa830c092a3989f"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(penguine)-jutexx-1"
  },
  {
    "_id": "67f42228faa830c092a398aa",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Grey)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052775/j1fjob8uigpfkx42vx5v.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052775/j1fjob8uigpfkx42vx5v.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f42228faa830c092a398ab"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(grey)-jutexx"
  },
  {
    "_id": "67f42249faa830c092a398bb",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Light Beige)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052809/egpm7fnvueb5grpmqqdq.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052809/egpm7fnvueb5grpmqqdq.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f42249faa830c092a398bc"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(light-beige)-jutexx"
  },
  {
    "_id": "67f42266faa830c092a398ce",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (orange red)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052838/ojpg4lwkcco3lxokhbl9.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052838/ojpg4lwkcco3lxokhbl9.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f42266faa830c092a398cf"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(orange-red)-jutexx"
  },
  {
    "_id": "67f42284faa830c092a398e3",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (doraemon)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052867/bfuwbxfetcwyeshvdydq.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052867/bfuwbxfetcwyeshvdydq.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f42284faa830c092a398e4"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(doraemon)-jutexx"
  },
  {
    "_id": "67f422a2faa830c092a398fa",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (red)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052897/erp6ylatb20v6qvsegvi.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052897/erp6ylatb20v6qvsegvi.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Penguine)",
        "_id": "67f422a2faa830c092a398fb"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(red)-jutexx"
  },
  {
    "_id": "67f422d4faa830c092a39913",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Dog)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052948/ot1tqhg8kwyrft1dlxzx.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052948/ot1tqhg8kwyrft1dlxzx.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Dog) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box (Dog)",
        "_id": "67f422d4faa830c092a39914"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(dog)-jutexx"
  },
  {
    "_id": "67f422f1faa830c092a39918",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (White Olive)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052976/ceqhyxlt31vi6jk05nwl.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744052976/ceqhyxlt31vi6jk05nwl.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (White Olive) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (White Olive)",
        "_id": "67f422f1faa830c092a39919"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(white-olive)-jutexx"
  },
  {
    "_id": "67f4231afaa830c092a3991d",
    "title": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (Joker)",
    "image": [
      {
        "src": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744053017/onilrgcxrjppvtc2ycaz.jpg",
        "dataAltImage": "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744053017/onilrgcxrjppvtc2ycaz.jpg",
        "alt": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (Joker) Model",
        "dataAltText": "Juteify Multi-Purpose Cute Jute Basket with Lid Storage Baskets for Bathroom Living Room & Kitchen Organiser Box Vanity Box First Aid Box  (Joker)",
        "_id": "67f4231afaa830c092a3991e"
      }
    ],
    "price": "Rs.599.00",
    "slug": "juteify-multi-purpose-cute-jute-basket-with-lid-storage-baskets-for-bathroom-living-room-and-kitchen-organiser-box-vanity-box-first-aid-box-(joker)-jutexx"
  }
]

export {basket, bowl , lBags , matka}